class Concepto{
    constructor(id, codigo, descripcion, tipo, codigo_afip){
        this.id = id;
        this.codigo = codigo;
        this.descripcion = descripcion;
        this.tipo = tipo;
        this.codigo_afip = codigo_afip;
    }
}
export default Concepto;
